
const MasterCalc = ([jan, feb, mar, apr, ma, jun, jul, aug, sep, oct, nov, dec], [tierType, surcharge, hasTax, tier1, tier2, tier3, tier4, sTier1, sTier2, sTier3, sTier4, wTier1, wTier2, wTier3, wTier4, tierAmount, sTierAmount, wTierAmount, tier1Amount, tier2Amount, tier3Amount, tier4Amount, sTier1Amount, sTier2Amount, sTier3Amount, sTier4Amount, wTier1Amount, wTier2Amount, wTier3Amount, wTier4Amount]) => {

  const charge = surcharge
  let tax = 1

  if (hasTax) {
    tax = 1.06
  }
  // console.log(tax)
  // cost per kWh



  // This returns the bill, average bill, total usage, annual bill and average usage. 
  // This then gets used to calculate all the important numbers...

  const tierOne = tier1
  const tierTwo = tier2
  const tierThree = tier3
  const tierFour = tier4

  const sTierOne = sTier1
  const sTierTwo = sTier2
  const sTierThree = sTier3
  const sTierFour = sTier4

  const wTierOne = wTier1
  const wTierTwo = wTier2
  const wTierThree = wTier3
  const wTierFour = wTier4

  const diffOne = tier2Amount - tier1Amount
  const diffTwo = tier3Amount - tier2Amount

  const sDiffOne = sTier2Amount - sTier1Amount
  const sDiffTwo = sTier3Amount - sTier2Amount

  const wDiffOne = wTier2Amount - wTier1Amount
  const wDiffTwo = wTier3Amount - wTier2Amount

  // console.log(sDiffOne, sDiffTwo)
  // console.log(sTier3Amount, sTier2Amount)


  // functions to get bill amounts for each month

  // console.log(tier1, sTierOne, 2, sTierTwo, 3, sTierThree)

  const month = (num) => {
    let tierOneCalc = tier1Amount * tierOne
    let tierTwoCalc = tierOneCalc + diffOne * tierTwo
    let tierThreeCalc = tierTwoCalc + diffTwo * tierTwo
    // let tierFourCalc = tierThreeCalc + (diffThree * tierTwo)
    // {console.log(tierOneCalc, tierTwoCalc, tier1Amount, diffOne)}

    if (tierAmount === 4) {
      if
        (num >= tier3Amount) {
        return ((num - tier3Amount) * tierFour + tierThreeCalc + charge) * tax
      } else if
        (num >= tier2Amount && num < tier3Amount) {
        return ((num - tier2Amount) * tierThree + tierTwoCalc + charge) * tax
      } else if
        (num >= tier1Amount && num < tier2Amount) {
        return ((num - tier1Amount) * tierTwo + tierOneCalc + charge) * tax
      } else {
        return (num * tierOne + charge) * tax
      }
    } else if (tierAmount === 3) {
      if
        (num >= tier2Amount) {
        return ((num - tier2Amount) * tierThree + tierTwoCalc + charge) * tax
      } else if
        (num >= tier1Amount && num < tier2Amount) {
        return ((num - tier1Amount) * tierTwo + tierOneCalc + charge) * tax
      } else {
        return (num * tierOne + charge) * tax
      }
    } else if (tierAmount === 2) {
      if
        (num >= tier1Amount) {
        return ((num - tier1Amount) * tierTwo + tierOneCalc + charge) * tax
      } else {
        return (num * tierOne + charge) * tax
      }
    } else {
      return (num * tierOne + charge) * tax
    }
  }


  const summer = (num) => {
    let sTierOneCalc = sTier1Amount * sTierOne
    let sTierTwoCalc = sTierOneCalc + sDiffOne * sTierTwo
    let sTierThreeCalc = sTierTwoCalc + sDiffTwo * sTierTwo
    // let tierFourCalc = sTierThreeCalc + (diffThree * tierTwo)
    // {console.log(sTierOneCalc, sTierTwoCalc, sTier1Amount, sDiffOne)}


    if (sTierAmount === 4) {
      if
        (num >= sTier3Amount) {
        return ((num - sTier3Amount) * sTierFour + sTierThreeCalc + charge) * tax
      } else if
        (num >= sTier2Amount && num < sTier3Amount) {
        return ((num - sTier2Amount) * sTierThree + sTierTwoCalc + charge) * tax
      } else if
        (num >= sTier1Amount && num < sTier2Amount) {
        return ((num - sTier1Amount) * sTierTwo + sTierOneCalc + charge) * tax
      } else {
        return (num * sTierOne + charge) * tax
      }
    } else if (sTierAmount === 3) {
      if
        (num >= sTier2Amount) {
        return ((num - sTier2Amount) * sTierThree + sTierTwoCalc + charge) * tax
      } else if
        (num >= sTier1Amount && num < sTier2Amount) {
        return ((num - sTier1Amount) * sTierTwo + sTierOneCalc + charge) * tax
      } else {
        return (num * sTierOne + charge) * tax
      }
    } else if (sTierAmount === 2) {
      if
        (num >= sTier1Amount) {
        return ((num - sTier1Amount) * sTierTwo + sTierOneCalc + charge) * tax
      } else {
        return (num * sTierOne + charge) * tax
      }
    } else {
      return (num * sTierOne + charge) * tax
    }
  }

  const winter = (num) => {
    let wTierOneCalc = wTier1Amount * wTierOne
    let wTierTwoCalc = wTierOneCalc + wDiffOne * wTierTwo
    let wTierThreeCalc = wTierTwoCalc + wDiffTwo * wTierTwo
    // let tierFourCalc = wTierThreeCalc + (diffThree * tierTwo)
    // {console.log(wTierOneCalc, wTierTwoCalc, wTier1Amount, wDiffOne)}


    if (wTierAmount === 4) {
      if
        (num >= wTier3Amount) {
        return ((num - wTier3Amount) * wTierFour + wTierThreeCalc + charge) * tax
      } else if
        (num >= wTier2Amount && num < wTier3Amount) {
        return ((num - wTier2Amount) * wTierThree + wTierTwoCalc + charge) * tax
      } else if
        (num >= wTier1Amount && num < wTier2Amount) {
        return ((num - wTier1Amount) * wTierTwo + wTierOneCalc + charge) * tax
      } else {
        return (num * wTierOne + charge) * tax
      }
    } else if (wTierAmount === 3) {
      if
        (num >= wTier2Amount) {
        return ((num - wTier2Amount) * wTierThree + wTierTwoCalc + charge) * tax
      } else if
        (num >= wTier1Amount && num < wTier2Amount) {
        return ((num - wTier1Amount) * wTierTwo + wTierOneCalc + charge) * tax
      } else {
        return (num * wTierOne + charge) * tax
      }
    } else if (wTierAmount === 2) {
      if
        (num >= wTier1Amount) {
        return ((num - wTier1Amount) * wTierTwo + wTierOneCalc + charge) * tax
      } else {
        return (num * wTierOne + charge) * tax
      }
    } else {
      return (num * wTierOne + charge) * tax
    }
  }

  let january
  let february
  let march
  let april
  let may
  let june
  let july
  let august
  let september
  let october
  let november
  let december

  if (tierType === 'Split') {
    january = winter(jan).toFixed(2)
    february = winter(feb).toFixed(2)
    march = winter(mar).toFixed(2)
    april = winter(apr).toFixed(2)
    may = summer(ma).toFixed(2)
    june = summer(jun).toFixed(2)
    july = summer(jul).toFixed(2)
    august = summer(aug).toFixed(2)
    september = summer(sep).toFixed(2)
    october = winter(oct).toFixed(2)
    november = winter(nov).toFixed(2)
    december = winter(dec).toFixed(2)
  } else {
    january = month(jan).toFixed(2)
    february = month(feb).toFixed(2)
    march = month(mar).toFixed(2)
    april = month(apr).toFixed(2)
    may = month(ma).toFixed(2)
    june = month(jun).toFixed(2)
    july = month(jul).toFixed(2)
    august = month(aug).toFixed(2)
    september = month(sep).toFixed(2)
    october = month(oct).toFixed(2)
    november = month(nov).toFixed(2)
    december = month(dec).toFixed(2)
  }
  // console.log(tierType)


  let bills = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let usage = [+jan, +feb, +mar, +apr, +ma, +jun, +jul, +aug, +sep, +oct, +nov, +dec]

  const average = (arr) => arr.reduce((a, b) => a + b) / arr.length
  const total = (arr) => arr.reduce((a, b) => a + b)

  let avgBill = average(bills).toFixed(2)
  let avgUsage = Math.floor(average(usage))
  let totalUsage = Math.floor(total(usage))
  let annualBill = total(bills).toFixed(2)

  return [bills, +avgBill, totalUsage, +annualBill, avgUsage]
}
export default MasterCalc